/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SetScheduleEnabledRequestBody = {
  /**
   * Whether the schedule should be polled.
   */
  enabled: boolean;
  /**
   * AI provider identifier. Supported values include cursor, anthropic_compliance, codex_compliance, and chatgpt_compliance.
   */
  provider: string;
  /**
   * Schedule identifier (e.g. cursor, anthropic_compliance, anthropic_analytics_usage).
   */
  schedule: string;
};

/** @internal */
export type SetScheduleEnabledRequestBody$Outbound = {
  enabled: boolean;
  provider: string;
  schedule: string;
};

/** @internal */
export const SetScheduleEnabledRequestBody$outboundSchema: z.ZodMiniType<
  SetScheduleEnabledRequestBody$Outbound,
  SetScheduleEnabledRequestBody
> = z.object({
  enabled: z.boolean(),
  provider: z.string(),
  schedule: z.string(),
});

export function setScheduleEnabledRequestBodyToJSON(
  setScheduleEnabledRequestBody: SetScheduleEnabledRequestBody,
): string {
  return JSON.stringify(
    SetScheduleEnabledRequestBody$outboundSchema.parse(
      setScheduleEnabledRequestBody,
    ),
  );
}
